import React from 'react';
import { observer } from 'mobx-react';
import * as IoC from 'typescript-ioc';
import Text from '../../../global/text/text';
import { DateTimeFormatter } from '../../../../infrastructure/implementations/date-formatter';
import { DateFnsFormats } from '../../../../infrastructure/date-formatter';
import { IOrderTemplateDTO } from '../../../../api/blueprints/order.template.types';
import DefaultButton from '../../../global/default-button/default-button';
import { Permission } from '../../../../api/roles.dao';
import { hasPermission } from '../../../../infrastructure/utils/has-permissions';
import { editText } from '../../../../constants/common-labels.constants';

type Props = {
    item: IOrderTemplateDTO;
    openEditModal: () => void;
};

export const OrderTemplatesListItem = observer((props: Props): JSX.Element => {
    const { item, openEditModal } = props;

    const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);
    const createdAt = dateTimeFormatter.dateToFormattedString(new Date(item.createdAt), DateFnsFormats.StringifiedMonthDayYear);
    const updatedAt = item.updatedAt && dateTimeFormatter.dateToFormattedString(new Date(item.updatedAt), DateFnsFormats.StringifiedMonthDayYear);
    const hasEditPermission = hasPermission(Permission.EDIT_ORDER_TEMPLATE);
    const onOpenEditModal = (): void => {
        if (!hasEditPermission) {
            return;
        }
        openEditModal();
    };

    return (
        <tr onDoubleClick={onOpenEditModal}>
            <Text tag='td' className='hoverable' message={item.name} withEllipsis />
            <Text tag='td' className='hoverable created-at--column' message={createdAt} />
            <Text tag='td' className='hoverable updated-at--column' message={updatedAt} />
            <Text tag='td' className='hoverable' message={item.description} withEllipsis />
            <td className='hoverable blueprint-actions'>
                <span style={{ height: '25px' }}></span> {/* span placeholder is for the "View Details" button, which is not implemented yet. This can be removed once "View Details" button is implemented. */}
                {hasEditPermission &&
                    <DefaultButton
                        text={editText()}
                        modifier='slim'
                        onClick={onOpenEditModal}
                        className='visible-while-hovered edit-template'
                    />
                }
            </td>
        </tr>
    );
});
